function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { classnames, throttle } from '@bydesign-ui/utils';
import { useImageManage } from '../../hooks/image';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDrag } from '../../hooks/drag';
import { getElementPosition } from '@bydesign-ui/hooks';
import { usePrefixCls } from '@byte-design/config';
import { useRefCallback } from '@bydesign-ui/hooks';
import { CropperDrag, Direct } from './CropperDrag';
export function Cropper(props) {
  var _props$url = props.url,
      url = _props$url === void 0 ? '' : _props$url,
      onError = props.onError,
      onChange = props.onChange,
      imageType = props.imageType,
      clipWidth = props.clipWidth,
      clipHeight = props.clipHeight,
      aspectRatio = props.aspectRatio,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 100 : _props$delay,
      _props$minWidth = props.minWidth,
      minWidth = _props$minWidth === void 0 ? 10 : _props$minWidth,
      _props$minHeight = props.minHeight,
      minHeight = _props$minHeight === void 0 ? 10 : _props$minHeight,
      _props$containerWidth = props.containerWidth,
      containerWidth = _props$containerWidth === void 0 ? 300 : _props$containerWidth,
      _props$containerHeigh = props.containerHeight,
      containerHeight = _props$containerHeigh === void 0 ? 300 : _props$containerHeigh,
      modalStyle = props.modalStyle;
  var previewUrl = useMemo(function () {
    return typeof url === 'string' ? url : URL.createObjectURL(url);
  }, [url]);
  var errorCallback = useRefCallback(onError);
  var changeCallback = useRefCallback(onChange);
  var imageManage = useImageManage(url, {
    imageType: imageType
  });
  var imgRef = useRef(null);
  var cropBoxRef = useRef(null);
  var containerRef = useRef(null);

  var _useState = useState(Direct.ALL),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var _useState3 = useState({
    top: 0,
    left: 0,
    width: 100,
    height: 100
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      dragPosition = _useState4[0],
      setDragPosition = _useState4[1];

  var _useState5 = useState({
    ratio: 1,
    scale: 1,
    naturalWidth: 0,
    naturalHeight: 0,
    width: containerWidth,
    height: containerHeight
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      cropInfo = _useState6[0],
      setCropInfo = _useState6[1];

  var containerCls = usePrefixCls('cropper-container');
  var modalCls = usePrefixCls('cropper-modal');
  var cropCls = usePrefixCls('cropper-crop');
  var viewBoxCls = usePrefixCls('cropper-view');
  var lineCls = usePrefixCls('cropper-line');
  var pointCls = usePrefixCls('cropper-point');
  var lineECls = classnames(lineCls, usePrefixCls('line-e'));
  var lineNCls = classnames(lineCls, usePrefixCls('line-n'));
  var lineWCls = classnames(lineCls, usePrefixCls('line-w'));
  var lineSCls = classnames(lineCls, usePrefixCls('line-s'));
  var pointECls = classnames(pointCls, usePrefixCls('point-e'));
  var pointNCls = classnames(pointCls, usePrefixCls('point-n'));
  var pointWCls = classnames(pointCls, usePrefixCls('point-w'));
  var pointSCls = classnames(pointCls, usePrefixCls('point-s'));
  var pointNECls = classnames(pointCls, usePrefixCls('point-ne'));
  var pointNWCls = classnames(pointCls, usePrefixCls('point-nw'));
  var pointSWCls = classnames(pointCls, usePrefixCls('point-sw'));
  var pointSECls = classnames(pointCls, usePrefixCls('point-se'));
  var handleChange = useMemo(function () {
    return throttle(function (position, scale) {
      var realInfo = {
        left: Math.floor(position.left * scale),
        top: Math.floor(position.top * scale),
        width: Math.floor(position.width * scale),
        height: Math.floor(position.height * scale)
      };
      imageManage.cropImage(realInfo.left, realInfo.top, realInfo.width, realInfo.height, clipWidth, clipHeight).then(function (res) {
        return changeCallback(res);
      }, function (err) {
        return errorCallback(err);
      });
    }, delay);
  }, []);
  var calcTargetOffset = useCallback(function (e, boundaries) {
    var normal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      x: true,
      y: true
    };
    var currentMousePos = e.currentMousePos,
        startMousePos = e.startMousePos;
    var targetPos = getElementPosition(cropBoxRef.current);
    var containerPos = getElementPosition(containerRef.current);
    var top = currentMousePos.pageY - startMousePos.pageY + dragPosition.top;
    var left = currentMousePos.pageX - startMousePos.pageX + dragPosition.left;
    left = Math.min(Math.max(left + (boundaries.left || 0), 0), containerPos.width - targetPos.width - (boundaries.right || 0));
    top = Math.min(Math.max(top + (boundaries.top || 0), 0), containerPos.height - targetPos.height - (boundaries.bottom || 0));
    var offsetX = Math.min(Math.max(normal.x ? -dragPosition.left : -dragPosition.width + minWidth, currentMousePos.pageX - startMousePos.pageX), normal.x ? dragPosition.width - minWidth : containerPos.width - dragPosition.width - dragPosition.left);
    var offsetY = Math.min(Math.max(normal.y ? -dragPosition.top : -dragPosition.height + minHeight, currentMousePos.pageY - startMousePos.pageY), normal.y ? dragPosition.height - minHeight : containerPos.height - dragPosition.height - dragPosition.top);
    return {
      top: Math.floor(top),
      left: Math.floor(left),
      offsetX: Math.floor(offsetX),
      offsetY: Math.floor(offsetY)
    };
  }, [dragPosition, minHeight, minWidth]);
  var calcRatioPosition = useCallback(function (newPosition) {
    if (!aspectRatio) {
      return;
    }

    var cWidth = cropInfo.width,
        cHeight = cropInfo.height;
    var maxWidth = dragPosition.width + Math.min(dragPosition.left, cWidth - dragPosition.left - dragPosition.width) * 2;
    var maxHeight = dragPosition.height + Math.min(dragPosition.top, cHeight - dragPosition.top - dragPosition.height) * 2;

    switch (type) {
      case Direct.LEFT:
      case Direct.RIGHT:
        {
          newPosition.height = Math.min(maxHeight, newPosition.width / aspectRatio);
          newPosition.width = newPosition.height * aspectRatio;
          newPosition.top = newPosition.top - (newPosition.height - dragPosition.height) / 2;

          if (type === Direct.LEFT && newPosition.height === maxHeight) {
            newPosition.left = dragPosition.left - (maxHeight - dragPosition.height) * aspectRatio;
          }

          break;
        }

      case Direct.UP:
      case Direct.DOWN:
        {
          newPosition.width = Math.min(maxWidth, newPosition.height * aspectRatio);
          newPosition.height = newPosition.width / aspectRatio;
          newPosition.left = newPosition.left - (newPosition.width - dragPosition.width) / 2;

          if (type === Direct.UP && newPosition.width === maxWidth) {
            newPosition.top = dragPosition.top - (maxWidth - dragPosition.width) / aspectRatio;
          }

          break;
        }

      case Direct.LEFT_UP:
      case Direct.LEFT_DOWN:
      case Direct.RIGHT_UP:
      case Direct.RIGHT_DOWN:
        {
          var MW = 0;
          var MH = 0;

          if (type === Direct.RIGHT_UP) {
            MW = cWidth - dragPosition.left;
            MH = dragPosition.height + dragPosition.top;
          }

          if (type === Direct.RIGHT_DOWN) {
            MW = cWidth - dragPosition.left;
            MH = cHeight - dragPosition.top;
          }

          if (type === Direct.LEFT_UP) {
            MW = dragPosition.width + dragPosition.left;
            MH = dragPosition.height + dragPosition.top;
          }

          if (type === Direct.LEFT_DOWN) {
            MW = dragPosition.width + dragPosition.left;
            MH = cHeight + dragPosition.top;
          }

          newPosition.height = Math.min(MH, newPosition.width / aspectRatio);
          newPosition.width = Math.min(MW, newPosition.height * aspectRatio);
          newPosition.height = newPosition.width / aspectRatio;

          if (type === Direct.RIGHT_UP || type === Direct.LEFT_UP) {
            newPosition.top = dragPosition.top - (newPosition.height - dragPosition.height);
          }

          if (type === Direct.LEFT_UP || type === Direct.LEFT_DOWN) {
            newPosition.left = dragPosition.left - (newPosition.width - dragPosition.width);
          }

          break;
        }
    }
  }, [type, cropInfo, dragPosition]);
  var calcDragPosition = useCallback(function (e) {
    var scale = cropInfo.scale;
    var newPosition = dragPosition;

    switch (type) {
      case Direct.ALL:
        {
          var _calcTargetOffset = calcTargetOffset(e, {}),
              left = _calcTargetOffset.left,
              top = _calcTargetOffset.top;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            left: left,
            top: top
          });
          break;
        }

      case Direct.RIGHT:
        {
          var _calcTargetOffset2 = calcTargetOffset(e, {}, {
            x: false,
            y: false
          }),
              offsetX = _calcTargetOffset2.offsetX;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            width: dragPosition.width + offsetX
          });
          break;
        }

      case Direct.LEFT:
        {
          var _calcTargetOffset3 = calcTargetOffset(e, {}),
              _offsetX = _calcTargetOffset3.offsetX;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            width: dragPosition.width - _offsetX,
            left: _offsetX + dragPosition.left
          });
          break;
        }

      case Direct.UP:
        {
          var _calcTargetOffset4 = calcTargetOffset(e, {}),
              offsetY = _calcTargetOffset4.offsetY;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            height: dragPosition.height - offsetY,
            top: offsetY + dragPosition.top
          });
          break;
        }

      case Direct.DOWN:
        {
          var _calcTargetOffset5 = calcTargetOffset(e, {}, {
            x: false,
            y: false
          }),
              _offsetY = _calcTargetOffset5.offsetY;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            height: dragPosition.height + _offsetY
          });
          break;
        }

      case Direct.LEFT_UP:
        {
          var _calcTargetOffset6 = calcTargetOffset(e, {}),
              _offsetY2 = _calcTargetOffset6.offsetY,
              _offsetX2 = _calcTargetOffset6.offsetX;

          newPosition = {
            width: dragPosition.width - _offsetX2,
            left: _offsetX2 + dragPosition.left,
            height: dragPosition.height - _offsetY2,
            top: _offsetY2 + dragPosition.top
          };
          break;
        }

      case Direct.RIGHT_UP:
        {
          var _calcTargetOffset7 = calcTargetOffset(e, {}, {
            x: false,
            y: true
          }),
              _offsetY3 = _calcTargetOffset7.offsetY,
              _offsetX3 = _calcTargetOffset7.offsetX;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            width: dragPosition.width + _offsetX3,
            height: dragPosition.height - _offsetY3,
            top: _offsetY3 + dragPosition.top
          });
          break;
        }

      case Direct.RIGHT_DOWN:
        {
          var _calcTargetOffset8 = calcTargetOffset(e, {}, {
            x: false,
            y: false
          }),
              _offsetY4 = _calcTargetOffset8.offsetY,
              _offsetX4 = _calcTargetOffset8.offsetX;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            width: dragPosition.width + _offsetX4,
            height: dragPosition.height + _offsetY4
          });
          break;
        }

      case Direct.LEFT_DOWN:
        {
          var _calcTargetOffset9 = calcTargetOffset(e, {}, {
            x: true,
            y: false
          }),
              _offsetY5 = _calcTargetOffset9.offsetY,
              _offsetX5 = _calcTargetOffset9.offsetX;

          newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
            width: dragPosition.width - _offsetX5,
            left: _offsetX5 + dragPosition.left,
            height: dragPosition.height + _offsetY5
          });
          break;
        }
    }

    calcRatioPosition(newPosition);
    handleChange(newPosition, scale);
    return newPosition;
  }, [dragPosition, calcRatioPosition, handleChange, calcTargetOffset]);
  var onDragging = useCallback(function (e) {
    if (!cropBoxRef.current || !containerRef.current) {
      return;
    }

    var _calcDragPosition = calcDragPosition(e),
        left = _calcDragPosition.left,
        top = _calcDragPosition.top,
        width = _calcDragPosition.width,
        height = _calcDragPosition.height;

    cropBoxRef.current.style.left = "".concat(left, "px");
    cropBoxRef.current.style.top = "".concat(top, "px");
    cropBoxRef.current.style.width = "".concat(width, "px");
    cropBoxRef.current.style.height = "".concat(height, "px");

    if (imgRef.current) {
      imgRef.current.style.left = "".concat(-left, "px");
      imgRef.current.style.top = "".concat(-top, "px");
    }
  }, [calcDragPosition]);
  var onDragEnd = useCallback(function (e) {
    var newPosition = calcDragPosition(e);
    setDragPosition(newPosition);
  }, [calcDragPosition, setDragPosition]);
  var initDragBox = useCallback(function (cropWidth, cropHeight, scale) {
    var dragWidth;
    var dragHeight;

    if (aspectRatio && aspectRatio !== 0) {
      dragWidth = cropHeight * aspectRatio;
      dragHeight = cropWidth / aspectRatio;

      if (dragWidth > cropWidth) {
        dragWidth = cropWidth;
        dragHeight = cropWidth / aspectRatio;
      } else {
        dragWidth = cropHeight * aspectRatio;
        dragHeight = cropHeight;
      }
    } else {
      dragWidth = cropWidth;
      dragHeight = cropHeight;
    }

    var newPosition = _objectSpread(_objectSpread({}, dragPosition), {}, {
      width: dragWidth,
      height: dragHeight
    });

    handleChange(newPosition, scale);
    setDragPosition(newPosition);
  }, [handleChange, setDragPosition]);
  var initImage = useCallback(function (naturalWidth, naturalHeight) {
    var ratio = naturalWidth / naturalHeight;
    var cropWidth;
    var cropHeight;

    if (naturalWidth > naturalHeight) {
      cropWidth = containerWidth;
      cropHeight = Math.round(containerWidth / ratio);
    } else {
      cropHeight = containerHeight;
      cropWidth = Math.round(containerHeight * ratio);
    }

    var scale = naturalWidth / cropWidth;
    setCropInfo({
      ratio: ratio,
      scale: scale,
      naturalWidth: naturalWidth,
      naturalHeight: naturalHeight,
      width: cropWidth,
      height: cropHeight
    });
    initDragBox(cropWidth, cropHeight, scale);
  }, [setCropInfo, initDragBox]);
  useEffect(function () {
    if (!url) {
      return;
    }

    var img = new Image();
    img.src = previewUrl;

    img.onload = function () {
      var naturalWidth = img.width;
      var naturalHeight = img.height;
      initImage(naturalWidth, naturalHeight);
    };
  }, [previewUrl]);
  useDrag(cropBoxRef, {
    onDragStart: function onDragStart() {
      return setType(Direct.ALL);
    },
    onDragging: onDragging,
    onDragEnd: onDragEnd
  });
  var imageCss = {
    width: "".concat(cropInfo.width, "px"),
    height: "".concat(cropInfo.height, "px"),
    left: "".concat(-dragPosition.left, "px"),
    top: "".concat(-dragPosition.top, "px")
  };
  var cropBoxCss = {
    top: dragPosition.top,
    left: dragPosition.left,
    width: "".concat(dragPosition.width, "px"),
    height: "".concat(dragPosition.height, "px")
  };
  var commonProps = {
    setType: setType,
    onDragEnd: onDragEnd,
    onDragging: onDragging
  };
  return React.createElement("div", {
    ref: containerRef,
    className: containerCls,
    style: {
      width: cropInfo.width,
      height: cropInfo.height,
      backgroundImage: "url(".concat(previewUrl, ")")
    }
  }, React.createElement("div", {
    className: modalCls,
    style: modalStyle
  }), React.createElement("div", {
    ref: cropBoxRef,
    style: cropBoxCss,
    className: cropCls
  }, React.createElement("span", {
    className: viewBoxCls
  }, React.createElement("img", {
    src: previewUrl,
    style: imageCss,
    ref: imgRef
  })), React.createElement(CropperDrag, Object.assign({
    className: lineECls,
    direct: Direct.RIGHT
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: lineNCls,
    direct: Direct.UP
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: lineWCls,
    direct: Direct.LEFT
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: lineSCls,
    direct: Direct.DOWN
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointECls,
    direct: Direct.RIGHT
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointNCls,
    direct: Direct.UP
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointWCls,
    direct: Direct.LEFT
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointSCls,
    direct: Direct.DOWN
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointNECls,
    direct: Direct.RIGHT_UP
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointNWCls,
    direct: Direct.LEFT_UP
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointSWCls,
    direct: Direct.LEFT_DOWN
  }, commonProps)), React.createElement(CropperDrag, Object.assign({
    className: pointSECls,
    direct: Direct.RIGHT_DOWN
  }, commonProps))));
}
export default Cropper;